import { ReactNode } from 'react';
import { Helmet } from 'react-helmet';

export interface IMetaTagProps {
	title: string;
	description?: string;
	children: ReactNode;
}

export function MetaTagWrapper({ title, description, children }: IMetaTagProps) {
	return (
		<>
			<Helmet>
				<title>{title} | 딸깍</title>

				{description && (
					<meta name="description" content={description} data-react-helmet="true" />
				)}
			</Helmet>
			{children}
		</>
	);
}
